import React from "react";
import "./ChangePasswordUnauth.scss";
import { TextField, Button } from "@material-ui/core";
import CheckIcon from "../../../resources/wrappers/CheckIcon";
import { AuthService } from "../../../services/authentication/AuthService";
import { MposLoader } from "../../../components/loader/MposLoader";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { ChangePasswordUnauthState } from "../../../states/ChangePasswordUnauthState";
import { HTTPResponses } from "../../../models/HTTPResponses";

export class ChangePasswordUnauth extends React.Component<any, ChangePasswordUnauthState> {
  private indexOtt: string;
  private ott: string;
  private resetType: string;

  constructor(props: any) {
    super(props);

    this.state = {
      newPassword: "",
      newPasswordConfirm: "",
      changePasswordError: false,
      buttonDisabled: true,
      digitChars: false,
      upperCaseChars: false,
      lowerCaseChars: false,
      numberOfChars: false,
      showLoader: false,
    };

    this.indexOtt = this.props.location.hash.replace("#", "").indexOf('?');
    this.ott = this.props.location.hash.replace("#", "").substring(0, this.indexOtt);
    this.resetType = this.props.location.hash.split("=")[this.props.location.hash.split("=").length - 1];

    if (!this.ott) {
      this.showResultDialog(this.props.history, HTTPResponses.KO);
      return;
    }

    this.openAppIfMobile();

    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleNewPasswordChanges = this.handleNewPasswordChanges.bind(this);
    this.handleConfirmNewPasswordChanges = this.handleConfirmNewPasswordChanges.bind(this);
  }

  componentDidMount() {
    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, "Recupero Password da link email", {});
  }

  private openAppIfMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = `neximpos://reset_credentials#${this.ott}`;
    }
  }

  private handleChangePassword(event: any) {
    event.preventDefault();
    if (this.state.newPassword === this.state.newPasswordConfirm) {
      this.setState({ changePasswordError: false, showLoader: true });

      AuthService.getInstance()
        .changePasswordFromReset(this.state.newPassword, this.state.newPasswordConfirm, this.ott)
        .subscribe(
          (result) => {
            this.setState({ showLoader: false });
            if (HTTPResponses.OK === result) {
              this.showResultDialog(this.props.history, HTTPResponses.OK);
            } else if (HTTPResponses.EXPIRED === result) {
              this.showResultDialog(this.props.history, HTTPResponses.EXPIRED);
            } else {
              this.showResultDialog(this.props.history, HTTPResponses.KO);
            }
          },
          () => {
            this.showResultDialog(this.props.history, HTTPResponses.KO);
          }
        );
    } else {
      this.setState({ changePasswordError: true });
    }
  }

  private showResultDialog(history: any, result?: HTTPResponses) {
    history.push("/resultUnauth", { resultCase: result, ott: this.ott, resetType: this.resetType });
  }

  private isPasswordValidated(): boolean {
    return this.state.numberOfChars && this.state.lowerCaseChars && this.state.upperCaseChars && this.state.digitChars;
  }

  private handlePasswordValidation() {
    if (this.isPasswordValidated()) {
      this.setState({ buttonDisabled: false, changePasswordError: false });
    } else {
      this.setState({ buttonDisabled: true });
    }
  }

  private handleNewPasswordChanges(event: any) {
    this.setState({ newPassword: event.target.value }, () => {
      this.verifyNewPasswordRules(this.state.newPassword);
    });
  }

  private handleConfirmNewPasswordChanges(event: any) {
    this.setState({ changePasswordError: false, newPasswordConfirm: event.target.value }, () => {
      if (this.state.newPassword === this.state.newPasswordConfirm) {
        this.handlePasswordValidation();
      }
    });
  }

  private verifyNewPasswordRules(newPassword: string) {
    this.setState({
      numberOfChars: newPassword.length >= 8 && newPassword.length <= 20,
      lowerCaseChars: /[a-z]/.test(newPassword),
      upperCaseChars: /[A-Z]/.test(newPassword),
      digitChars: /\d/.test(newPassword),
    });
  }

  private checkPassword() {
    if (this.state.newPasswordConfirm !== "") {
      this.checkConfirmPassword();
    }
  }

  private checkConfirmPassword() {
    if (this.state.newPassword === this.state.newPasswordConfirm) {
      this.handlePasswordValidation();
    } else {
      this.setState({ buttonDisabled: true, changePasswordError: true });
      GoogleTagManagerService.getInstance().pushCustomError("custom_error", "input", null, "le password non coincidono. Riprova", "newPasswordConfirm", false);
    }
  }

  render() {
    return (
      <div id={"main-container-change-password"}>
        <div id={"form-change-password-box-container"}>
          <div className={"form-change-password-box-content"}>
            <div>
              <p className="recupero-password">Recupero password</p>
              <p id={"change-password-title"}>Scegli la tua nuova password</p>
            </div>
            <div className={"change-password-form-content"}>
              <form onSubmit={this.handleChangePassword}>
                <div>
                  <TextField
                    id="newPassword"
                    label="Scrivi la nuova password"
                    onBlur={() => {
                      this.checkPassword();
                    }}
                    type="password"
                    onChange={this.handleNewPasswordChanges}
                    value={this.state.newPassword}
                    inputProps={{ maxLength: 20 }}
                  />
                  <div className={"change-password-rules-container"}>
                    <p className={"change-password-text-suggestions"}>
                      La password deve contenere da 8 a 20 caratteri e soddisfare tutti i seguenti requisiti:
                    </p>
                    <div className={"change-password-rules-row"}>
                      <div className={"change-password-rules-row-icon"}>
                        <CheckIcon color={!this.state.lowerCaseChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                      </div>
                      <div className={"change-password-rules-row-text"}>
                        <p className={!this.state.lowerCaseChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>
                          {"Una lettera minuscola".toUpperCase()}
                        </p>
                      </div>
                    </div>
                    <div className={"change-password-rules-row"}>
                      <div className={"change-password-rules-row-icon"}>
                        <CheckIcon color={!this.state.upperCaseChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                      </div>
                      <div className={"change-password-rules-row-text"}>
                        <p className={!this.state.upperCaseChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>
                          {"Una lettera maiuscola".toUpperCase()}
                        </p>
                      </div>
                    </div>
                    <div className={"change-password-rules-row"}>
                      <div className={"change-password-rules-row-icon"}>
                        <CheckIcon color={!this.state.digitChars ? "#9596AF" : "#0B8252"} width={"40px"} height={"29px"} />
                      </div>
                      <div className={"change-password-rules-row-text"}>
                        <p className={!this.state.digitChars ? "change-password-rules-row-text-ko" : "change-password-rules-row-text-ok"}>
                          {"Un numero".toUpperCase()}
                        </p>
                      </div>
                    </div>
                  </div>
                  <TextField
                    id="confirmPassword"
                    label="Conferma la nuova password"
                    type="password"
                    onChange={this.handleConfirmNewPasswordChanges}
                    value={this.state.newPasswordConfirm}
                    error={this.state.changePasswordError}
                    inputProps={{ maxLength: 20 }}
                    onBlur={() => {
                      this.checkConfirmPassword();
                    }}
                  />
                  <p className={`change-password-error-label ${this.state.changePasswordError ? "" : "change-password-error-label-hidden"}`}>
                    Le password non coincidono. Riprova.
                  </p>
                </div>
                <div className={"form-elements"}>
                  <Button className={"change-password-submit-button"} type={"submit"} disabled={this.state.buttonDisabled}>
                    CONFERMA
                  </Button>
                </div>
                {
                  // @ts-ignore
                  <MposLoader show={this.state.showLoader} />
                }
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
